import { render, staticRenderFns } from "./editDocumentClassification.vue?vue&type=template&id=e897ee32&scoped=true"
import script from "./editDocumentClassification.vue?vue&type=script&lang=js"
export * from "./editDocumentClassification.vue?vue&type=script&lang=js"
import style0 from "./editDocumentClassification.vue?vue&type=style&index=0&id=e897ee32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e897ee32",
  null
  
)

export default component.exports